module.exports = __webpack_public_path__ + "img/2.367e36e4.png";